import {TaxEstimation} from '@sportngin/se-commerce-sdk';
import {CartItem, ProductReference} from 'src/app/data/model';

/**
 * Please ensure you update the documentation with all event types and their respective event types
 * https://se-commerce-docs.ui.sportsengine.com/embeddable-store/event-listeners#event-types
 * @see /packages/docs/docs/embeddable-store/05-event-listeners.mdx
 */

export interface AuthenticateEvent {
  accessToken: string | null;
  refreshToken: string | null;
}

export interface CommercePurchaseMetadata {
  guestKey?: string;
  organizationId?: number;
  baseUriProxy?: string;
  references?: ProductReference;
}

export interface CartChangeEventOptions extends CommercePurchaseMetadata {
  displayItems?: CartItem[];
}

export class CartChangeEvent {
  subtotal: number;
  items: CartItem[];
  displayItems: CartItem[];
  guestKey?: string;
  organizationId?: number;
  baseUriProxy?: string;
  references?: ProductReference;

  constructor(
    items: CartItem[],
    tax?: TaxEstimation,
    options: CartChangeEventOptions = {},
  ) {
    this.items = items;
    this.displayItems = options.displayItems ?? items;
    this.guestKey = options.guestKey;
    this.organizationId = options.organizationId;
    this.baseUriProxy = options.baseUriProxy;
    this.references = options.references;
    this.subtotal = this.calculateSubtotal(items, tax);
  }

  protected calculateSubtotal(items: CartItem[], tax?: TaxEstimation): number {
    let subtotal = 0;
    for (const item of items) {
      subtotal += Number(item.unitPrice) * item.quantity;
    }
    if (tax?.totalEstimatedTax) {
      subtotal += Number(tax.totalEstimatedTax.replace('$', ''));
    }
    // Prevent floating point javascript math
    return Number(subtotal.toFixed(2));
  }
}

export interface ContinueEvent {
  action: 'continue' | 'registerAnother';
  items?: CartItem[];
  displayItems?: CartItem[];
  subtotal?: number;
  guestKey?: string;
  organizationId?: number;
  baseUriProxy?: string;
  references?: ProductReference;
}

export interface NavigationEvent {
  totalPages: number;
  currentPage: number;
  currentRoute?: string;
  nextRoute?: string;
  previousRoute?: string;
}

export interface AddOnErrorEvent {
  message: string;
  code: number;
  data?: unknown;
}
